function canTriggerSequencerMutation({ hasMutationAccess, actionAvailable = true } = {}) {
    return hasMutationAccess !== false && Boolean(actionAvailable);
}

function canTriggerPasteClipboardBeforeSelection({
    hasMutationAccess,
    isPasteActionAvailable = false,
} = {}) {
    return canTriggerSequencerMutation({
        hasMutationAccess,
        actionAvailable: isPasteActionAvailable,
    });
}

function canTriggerWrapSelectedNodesWithMusic({
    hasMutationAccess,
    isWrapActionAvailable = false,
    isOnboardingDisplayed = false,
} = {}) {
    return !isOnboardingDisplayed && canTriggerSequencerMutation({
        hasMutationAccess,
        actionAvailable: isWrapActionAvailable,
    });
}

function canTriggerIgnoreSelectedNodes({
    hasMutationAccess,
    hasModel = true,
    isOnboardingDisplayed = false,
    isSearchOn = false,
    isSearchInputFocused = false,
} = {}) {
    if(!hasModel || isOnboardingDisplayed){
        return false;
    }

    if(!canTriggerSequencerMutation({ hasMutationAccess })){
        return false;
    }

    return !(isSearchOn && isSearchInputFocused);
}

function canTriggerTranscriptCorrection({
    hasMutationAccess,
    isTranscriptCorrectionAvailable = false,
} = {}) {
    return canTriggerSequencerMutation({
        hasMutationAccess,
        actionAvailable: isTranscriptCorrectionAvailable,
    });
}

function canTriggerAdjustTiming({
    hasMutationAccess,
    isAdjustTimingAvailable = false,
} = {}) {
    return canTriggerSequencerMutation({
        hasMutationAccess,
        actionAvailable: isAdjustTimingAvailable,
    });
}

function canDisplayMoreOptionMenu({
    hasMutationAccess,
    hasClipboardFeature = false,
    hasClippingFeature = false,
    hasCopyActionAvailable = false,
    hasDownloadClipAvailable = false,
} = {}) {
    if(hasMutationAccess === false){
        return Boolean(hasCopyActionAvailable || hasDownloadClipAvailable);
    }

    return Boolean(
        hasClipboardFeature ||
        hasClippingFeature ||
        hasDownloadClipAvailable
    );
}

module.exports = {
    canDisplayMoreOptionMenu,
    canTriggerAdjustTiming,
    canTriggerIgnoreSelectedNodes,
    canTriggerPasteClipboardBeforeSelection,
    canTriggerSequencerMutation,
    canTriggerTranscriptCorrection,
    canTriggerWrapSelectedNodesWithMusic,
};
